export const getItem = <T = unknown>(
  key: string,
  isPersistent = false,
): T | undefined => {
  let value = undefined;

  try {
    value = isPersistent
      ? localStorage.getItem(key)
      : sessionStorage.getItem(key);

    if (value === null || value === '') {
      return undefined;
    }

    return JSON.parse(value) as T;
  } catch {
    return value as T;
  }
};

export const setItem = (
  key: string,
  value: unknown,
  isPersistent = false,
): void => {
  const stringifiedValue =
    typeof value === 'string' ? value : JSON.stringify(value);
  isPersistent
    ? localStorage.setItem(key, stringifiedValue)
    : sessionStorage.setItem(key, stringifiedValue);
};

export const removeItem = (key: string, isPersistent = false): void => {
  isPersistent ? localStorage.removeItem(key) : sessionStorage.removeItem(key);
};

export const findItem = (key: string): unknown => {
  return getItem(key) ?? getItem(key, true);
};

export const popItem = (key: string, isPersistent = false): unknown => {
  const value = getItem(key, isPersistent);
  removeItem(key, isPersistent);
  return value;
};
